<template>
    <div>
        <aside
            class="left-sidebar"
            data-sidebarbg="skin5"
            v-bind:class="{ min: activarLateral }"
        >
            <div class="scroll-sidebar">
                <nav class="sidebar-nav" :key="refresh">
                    <ul id="sidebarnav">
                        <li
                            class="sidebar-item"
                            v-for="(i, index) in menuLateral"
                            :key="index"
                            v-bind:class="{ sub: i.type === 2 }"
                        >
                            <router-link
                                :to="i.ruta"
                                exact-active-class="active"
                                class="sidebar-link waves-effect waves-dark"
                                v-if="i.type == 1"
                            >
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }}</span>
                            </router-link>
                            <div
                                v-else-if="i.type == 2"
                                class="sidebar-link has-arrow waves-effect waves-dark"
                                v-on:click="activeSubMenu(i)"
                                v-bind:class="{ active: i.mActive }"
                                aria-expanded="false"
                            >
                                <i :class="i.icon"></i>
                                <span class="hide-menu">{{ i.name }} </span>
                            </div>

                            <ul
                                aria-expanded="false"
                                class="collapse first-level"
                                v-bind:class="{ in: i.mActive }"
                                v-if="i.items.length>0"
                            >
                                <li
                                    class="sidebar-item"
                                    v-for="(item, index2) in i.items"
                                    :key="index2"
                                >
                                    <router-link
                                        :to="item.ruta"
                                        exact-active-class="active"
                                        class="sidebar-link"
                                    >
                                        <span class="hide-menu">{{ item.name }}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="sidebar-item" v-if="planActual==planStandardId || planActual==planFreeId">
                            <div class="sidebar-link waves-effect waves-dark changePlan"
                                @click="showChangePlan()"
                                style=""
                            >
                                <i class="fas fa-gem"></i>
                                <span class="hide-menu">{{ lang.aside_update_now }}</span>
                            </div>
                        </li>
                    </ul>
                </nav>
                <div class="btnAsideAction" @click="ShowHiddenAside">
                    <i
                        class="fas fa-chevron-left"
                        v-bind:class="{ min: activarLateral }"
                    ></i>
                </div>
            </div>
        </aside>
        <modal
            name="modal-form"
            height="auto"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
        >
            <i
                class="fas fa-times"
                style="
                    position: absolute;
                    top: 9px;
                    right: 11px;
                    font-size: 24px;
                    cursor: pointer;
                    z-index: 99;
                "
                @click="CloseModal"
            ></i>
            <component :is="renderComponent"></component>
        </modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: "Aside",
    components: {
    },
    data() {
        return {
            isMoneyIn: true,
            isMoneyOut: false,
            activarLateral: false,
            winnerWidth: window.innerWidth,
            menuLateral: {},
            renderComponent: "",
            inputActive: null,
            indiceIn: 0,
            indiceOut: 0,
            PlanPremium: false,
            premiumProfile: false,
            planesPro: [],
            planFreeId: 8,
            planStandardId: 5,
            lang: {},
            refresh: 0,
        };
    },
    created() {
        let t=this;
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
        // valid premium planID
        // console.log('get_isPremiumProfile', t.$store.getters['ModApps/Marketea/get_isPremiumProfile']);
        t.planesPro = t.$store.getters['ModApps/Marketea/get_planesPro'];
        t.PlanPremium = (t.$store.getters['core/apps/getPlanIdApp']==6 || t.$store.getters['core/apps/getPlanIdApp']==11);
        t.premiumProfile = t.$store.getters['ModApps/Marketea/get_isPremiumProfile'];
        // console.log('PlanPremium', t.PlanPremium);
        t.planActual = t.$store.getters['core/apps/getPlanIdApp'];
        if(t.planActual==7){
            t.PlanPremium = true;
            // console.log('Plan sponsored, dando permiso de premium', t.PlanPremium);
        }
        // console.log('created getModulesMenu', t.getModulesMenu)
    },
    methods: {
        showChangePlan(){
            let t = this;
            let appData = {
                app_id: 8,
                show: true,
                infoApp: null,
                planes: [],
            }
            t.$store.commit("core/set_showSuscription", appData);
        },
        ShowHiddenAside() {
            this.activarLateral = !this.activarLateral;
            this.$emit("activarLateral", this.activarLateral);
        },
        async estructuraMenu() {
            let t= this;
            this.menuLateral = []
            this.menuRutas = {
                0: {
                    name: this.lang.aside_smart_card,
                    ruta: { name: "smartCard" },
                    icon: "fas fa-id-card",
                    type: 1,
                    m_id: 13,
                    items: [],
                },
                1: {
                    name: this.lang.aside_forms,
                    icon: "fas fa-table",
                    ruta: { name: "forms" },
                    type: 2,
                    mActive: false,
                    items: [
                        {
                            name: this.lang.aside_list,
                            ruta: { name: "listForms" },
                            m_id: 7,
                        },
                        {
                            name: this.lang.aside_alert_response,
                            ruta: { name: "AlertForm" },
                            m_id: 8,
                        },
                        {
                            name: this.lang.aside_notifications,
                            ruta: { name: "notiForms" },
                            m_id: 9,
                        },
                        {
                            name: this.lang.aside_btn_call_link,
                            ruta: { name: "btnCallLink" },
                            m_id: 18,
                        },
                    ],
                },
                2: {
                    name: this.lang.aside_bstore,
                    ruta: { name: "bsite_bStore" },
                    icon: "fas fa-store",
                    type: 2,
                    mActive: false,
                    m_id: 19,
                    items: [
                        {
                            name: this.lang.aside_products,
                            ruta: { name: "bsite_bStore_products" },
                            m_id: 20,
                        },
                        {
                            name: this.lang.aside_orders,
                            ruta: { name: "bsite_bStore_orders" },
                            m_id: 21,
                        },
                        {
                            name: this.lang.aside_todays_deals,
                            ruta: { name: "bsite_bStore_deals" },
                            m_id: 22,
                        },
                    ],
                },
                3: {
                    name: this.lang.aside_plugins,
                    ruta: { name: "plugins" },
                    icon: "fas fa-puzzle-piece",
                    type: 2,
                    mActive: false,
                    m_id: 8,
                    items: [
                        {
                            name: this.lang.aside_projects,
                            ruta: { name: "ProjectsAll" },
                            m_id: 9,
                        },
                        // {
                        //     name: this.lang.aside_gallery,
                        //     ruta: { name: "bsite_gallery" },
                        //     m_id: 11,
                        // },
                        {
                            name: this.lang.aside_bmenu,
                            ruta: { name: "bsite_bmenu" },
                            m_id: 12,
                        },
                    ],
                },
                4: {
                    name: this.lang.aside_setup,
                    ruta: { name: "MSetup" },
                    icon: "fas fa-cog",
                    type: 1,
                    m_id: 12,
                    items: [],
                },
            };
            this.menuLateral = Object.values(this.menuRutas);
            /*
            for (const e in t.getModulesMenu) {
                if (Object.hasOwnProperty.call(t.getModulesMenu, e)) {
                    let menuPlan = t.getModulesMenu[e];
                    // console.log('buscar module_key', menuPlan.module_key)
                    for (const r in t.menuRutas) {
                        if(t.menuRutas[r].ruta.name == menuPlan.module_key){
                            // console.log('encontrado', t.menuRutas[r].ruta.name)
                            let setItem = {
                                name: menuPlan.module_name,
                                ruta: { "name": menuPlan.module_key },
                                icon: t.menuRutas[r].icon,
                                type: menuPlan.type_mod,
                                m_id: menuPlan.id,
                                mActive: false,
                                items: []
                            };
                            if(menuPlan.type_mod==2){
                                let subRutas = t.menuRutas[r].items;
                                // if(Object.keys(subRutas).length>0){
                                if(subRutas.length>0){
                                    // console.log('validando submenu', subRutas, menuPlan.subMenu
                                    for (const i in menuPlan.subMenu) {
                                        if (Object.hasOwnProperty.call(menuPlan.subMenu, i)) {
                                            const subMenu = menuPlan.subMenu[i];
                                            for (const s in subRutas) {
                                                if (Object.hasOwnProperty.call(subRutas, s)) {
                                                    if(subRutas[s].ruta.name==subMenu.module_key){
                                                        if(menuPlan.plugins==1) {
                                                            let payload = {id: subMenu.id, slug: subMenu.module_key};
                                                            const isExist_plugin = await t.$store.dispatch("ModApps/Marketea/search_plugins", payload); //.then(p => {
                                                                // console.log('submenu encontrado en plugins', isExist_plugin)
                                                                if(isExist_plugin!=null && isExist_plugin!=undefined){
                                                                    let setSubMenu={
                                                                        name: subMenu.module_name,
                                                                        ruta: { name: subMenu.module_key },
                                                                        m_id: subMenu.id,
                                                                    }
                                                                    setItem.items.push(setSubMenu);
                                                                }
                                                            // });
                                                        }else{
                                                            let setSubMenu={
                                                                name: subMenu.module_name,
                                                                ruta: { name: subMenu.module_key },
                                                                m_id: subMenu.id,
                                                            }
                                                            setItem.items.push(setSubMenu);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    console.log('setItem items', setItem.items)
                                    if(setItem.items.length>0){
                                        t.menuLateral.push(setItem);
                                    }
                                }
                            } else {
                                t.menuLateral.push(setItem);
                            }
                        }
                    }
                }
            }*/
            // console.log('menuPlan', t.menuLateral)
        },
        ShowForm() {
            this.$modal.show("modal-form");
            this.renderComponent = "Formtest";
        },
        CloseModal() {
            this.$modal.hide("modal-form");
            this.renderComponent = "";
        },
        validarMenu() {
            let menu = [];
            if (window.user_type == 0) {
                menu = this.menuLateral;
                this.indiceIn = 3;
                this.indiceOut = 4;
            } else {
            }
        },
        activeSubMenu(i) {
            let menuLateral = this.menuLateral   
            for (const j in menuLateral) {
                if (menuLateral[j].mActive !== undefined) {
                    if (menuLateral[j].mActive && menuLateral[j] != i) { 
                        this.menuLateral[j].mActive = false;
                    } 
                    if(menuLateral[j] == i) {
                        this.menuLateral[j].mActive = !this.menuLateral[j].mActive;
                    }
                }
            }
        },
    },
    mounted: function () {
        let t = this;
        t.estructuraMenu();
        // t.validarMenu();
        if (t.winnerWidth < 1050) {
            t.ShowHiddenAside();
        }
    },
    watch: {
        getModulesMenu: function(){
            let t = this;
            // console.log('watch getModulesMenu', t.getModulesMenu)
            t.estructuraMenu();
        },
        langGetter: function(newLang){
            // console.log('watch langGetter', newLang)
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
            this.estructuraMenu();
            this.refresh++;
        }
    },
    computed: {
        ...mapGetters("core", { getPusher: "get_accitonPusher"}),
        ...mapGetters("core/apps/", { getModulesMenu: "getModulesMenu" }),
        ...mapGetters("ModApps/Marketea", { langGetter: "lang" })
    },
};
</script>
<style lang="scss" scoped>
    .left-sidebar {
        position: fixed;
    }
    .btnAsideAction {
        position: absolute;
        bottom: -18px;
        top: initial;
        left: 0;
        width: 100%;
        height: 40px;
        background-color: #343435;
        cursor: pointer;
        padding: 10px 4px 4px 4px;
        line-height: 21px;
        text-align: center;
        color: #fff;
    }
    aside.left-sidebar.min {
        width: 60px;
        z-index: 100;
    }
    aside.left-sidebar.min .scroll-sidebar {
        height: 100%;
    }
    aside.left-sidebar.min .scroll-sidebar .btnAsideAction {
        bottom: 0%;
    }
    aside.left-sidebar.min .scroll-sidebar .btnAsideAction i:before {
        content: "\f054";
    }
    aside.left-sidebar.min .scroll-sidebar nav.sidebar-nav ul#sidebarnav li.sidebar-item,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        ul.collapse.first-level
        li.sidebar-item {
        width: 60px;
        transition: all 0.5s ease-out;
        position: relative;
    }

    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level.in {
        position: absolute;
        top: 0px;
        left: 40px;
        width: 170px;
    }

    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        a.sidebar-link {
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        a.sidebar-link
        span.hide-menu,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        div.sidebar-link
        span.hide-menu,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        ul.collapse.first-level,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        ul.collapse.first-level.in {
        display: none;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level.in,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level
        li.sidebar-item
        a.sidebar-link
        span.hide-menu {
        display: block;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level
        li.sidebar-item
        a.sidebar-link {
        border-left: 2px solid transparent;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        a.sidebar-link,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        div.sidebar-link.has-arrow.waves-effect.waves-dark,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        div.sidebar-link.has-arrow.waves-effect.waves-dark.active {
        border-left: 2px solid #137eff;
        opacity: 1;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        div.sidebar-link,
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item:hover
        ul.collapse.first-level {
        background: #191919;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        > .has-arrow::after {
        transition: all 0.5s ease-out;
    }
    aside.left-sidebar.min
        .scroll-sidebar
        nav.sidebar-nav
        ul#sidebarnav
        li.sidebar-item
        > .has-arrow::after {
        -webkit-transform: rotate(135deg) translate(0, -50%) !important;
        transform: rotate(135deg) translate(0, -50%) !important;
    }
    .changePlan{
        border: 1px solid;
        border-left: 1px solid !important;
        width: 100%;
        max-width: 150px;
        border-radius: 30px;
        margin: 20px auto;
    }
    @media (max-width: 1024px) {
        .sidebar-nav ul .sidebar-item .sidebar-link {
            padding: 8px 8px;
        }
        .changePlan{
            border: 0px solid;
            border-left: 0px solid !important;
            max-width: 100%;
        }
    }

</style>
